export const toPercentage = (dividend: number, base: number, shouldSubtract?: boolean) => {
  return shouldSubtract
    ? parseFloat((((dividend - base) / base) * 100).toFixed(2))
    : parseFloat(((dividend / base) * 100).toFixed(2))
}
